const SportsModule = () => import(/* webpackChunkName: "sports-module" */ './views/Module.vue'); 
const Sports = () => import(/* webpackChunkName: "sports" */ './views/Sports.vue');
const SportEventDetail = () => import(/* webpackChunkName: "sport-event-detail" */ './views/SportEventDetail.vue');
const BetExchange = () => import(/* webpackChunkName: "sport-event-detail" */ './views/BetExchange.vue');
const SportsBetting = () => import(/* webpackChunkName: "sport-event-detail" */ './views/SportsBetting.vue');

const SportsRoutes =   {
    path: '/',
    component: SportsModule,
    children: [
      {
        path: 'bet-exchange',
        name: 'bet-exchange',
        component: BetExchange
      },
      {
        path: 'sports/:type/:id',
        name: 'sports',
        component: Sports
      },
      {
        path: 'sports-event-detail/:event_id',
        name: 'sports-event-detail',
        component: SportEventDetail
      },
      {
        path: 'sports-betting/:sports_id',
        name: 'sports-betting',
        component: SportsBetting
      },
    ],
  }

export default SportsRoutes;